import { FC } from "react";
import { Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { githubUsername, linkedInUsername } from "../../../../constants/personalInfo/personalInfo.ts";
import { ReactComponent as GitHubIcon } from "../../../../assets/svg/socials/github-brands-solid.svg";
import { ReactComponent as LinkedInIcon } from "../../../../assets/svg/socials/linkedin-brands-solid.svg";

const Socials: FC = () => {
    const {
        t
    } = useTranslation('footer');
    
    return (
        <Col
            md={4}
            sm={12}
        >
            <h5>
                {t('socials.title')}
            </h5>
            <ul>
                <li>
                    <GitHubIcon />
                    <a
                        href={`https://github.com/${githubUsername}`}
                        target="_blank"
                        rel="noopener noreferrer"
                    > 
                        GitHub
                    </a>
                </li>
                <li>
                    <LinkedInIcon />
                    <a
                        href={`https://linkedin.com/in/${linkedInUsername}`}
                        target="_blank"
                        rel="noopener noreferrer"
                    > 
                        LinkedIn
                    </a>
                </li>
            </ul>
        </Col>
    )
};

export default Socials;